import {
  httpCollection,
} from "us.helper/http/collection";

export default {
  getRemitDetails: {
    get: (journalId: string | number): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "paymentservice",
            `remit/details?journalid=${journalId}`,
            {}
          );
          resolve({data, status});
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
